import React from "react";

/**
 * Reusable section header with eyebrow + h2 + optional description.
 */
export default function SectionHeader({ eyebrow, title, description, align = "left", className = "" }) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignment} ${className}`}>
      {eyebrow && <div className="eyebrow mb-4" data-testid="section-eyebrow">{eyebrow}</div>}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">{description}</p>
      )}
    </div>
  );
}
